import { useQuery } from '@tanstack/react-query';
import qs from 'qs';
import api from '../domain/api';

export const useActivities = (pageNumber = '') =>
  useQuery(
    ['activities', pageNumber],
    async () => {
      const queryParams = qs.parse(window.location.search.replace('?', ''));
      const query = qs.stringify(queryParams, { encodeValuesOnly: true });
      const { data } = await api.get(
        `/activitys?pageNumber=${pageNumber}&${query}`
      );

      return data;
    },
    {
      keepPreviousData: true,
      staleTime: 1000 * 60 * 5,
      retry: 1,
    }
  );
